{
  "rememberMe": "Remember me",
  "signIn": "Sign In",
  "signUp": "Create an account",
  "signUpLink": "Don't have an account?",
  "continueAsGuest": "Continue as guest",
  "forgotPassword": "Forgot Password",
  "forgotPasswordLink": "Forgot your password?",
  "setPassword": "Set Password",
  "codeVerification": "Code Verification",
  "verifyMessage": "We have sent a verification code to your email address",
  "changePassword": "Change Password",
  "signOut": "Sign Out",
  "deleteAccount": "Delete Account",
  "availableProfiles": "Available Profiles",
  "selectProfile": "Select profile",
  "noProfiles": "No profiles available",
  "switchProfile": "Switch Profile",
  "alreadyHaveCode": "Already have a verification code?",
  "tempPassMessage": "Please replace your temporary password",
  "mfa": {
    "settings": "MFA Settings",
    "SMS": "SMS",
    "TOTP": "Authenticator App",
    "noPreference": "No Preference",
    "enabledMFAMethods": "Enabled MFA Methods",
    "preferredMFAMethod": "Preferred MFA Method",
    "setupTOTPMFA": "Set-up Authenticator App MFA",
    "setupSMSMFA": "Set-up SMS MFA",
    "disableTOTPMFA": "Disable Authenticator App MFA",
    "disableSMSMFA": "Disable SMS MFA",
    "TOTPSetup": "Authenticator App Set-up",
    "SMSSetup": "SMS Set-up",
    "secretKey": "Secret Key",
    "installAuthApp": "Install an authenticator app on your mobile device",
    "addAnAccount": "Add an account",
    "scanQRCode": "Scan the following QR code:",
    "or": "Or...",
    "addSecretManually": "Add the secret key to your authenticator app manually:",
    "copySecretKey": "Copy secret key",
    "regenSecretKey": "Regenerate secret key",
    "ensureAccountCreated": "Ensure that '{appName}' account has been created",
    "verifySetup": "Verify your set-up:",
    "done": "Done",
    "otpMessage": "Enter your one-time code from your authenticator app",
    "smsMessage": "We have sent a verification code to you via SMS",
    "setupAuthAppMessage": "Need to set-up your authenticator app?",
    "signUpOptionalMobileMessage": "Adding your mobile number will let you use SMS for multi-factor authentication (MFA). If you do not add a mobile number, you will need to set up MFA using an Authenticator app (like Google Authenticator) when you log in for the first time.",
    "mfaSelectionHeader": "MFA selection",
    "mfaSelectionMessage": "Please choose how you want to receive your one-time code"
  },
  "ssoButtons": {
    "divider": "or",
    "continueSso": "Continue with SSO",
    "continueMs": "Continue with Microsoft",
    "continueGoogle": "Continue with Google",
    "continueApple": "Continue with Apple"
  }
}
